import { Layout } from './types';

/* 
    Class that provides the layouts for multiple parts:
    - VisibilityTracker: to check which items are visible / engaged.
    - VirtualRenderer: to be able to interact with RecyclePool (based on layout type)
    - GridView: to assign proper x, y, width, height for ItemContainer
*/

export class LayoutProvider {
    private _layouts: Layout[][] = [];

    constructor(layouts: Layout[][]) {
        this._layouts = layouts;
    }

    public getLayouts = () => {
        return this._layouts;
    };

    public getLayout = (rowIndex: number, index: number) => {
        return this._layouts[rowIndex][index];
    };
}
